module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1033-ad7dae23cf94a5626fc345397ebc0188.png";